<app-chat>
</app-chat>
<router-outlet />